var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediaDocument({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.272,
    height: 40.579,
    viewBox: "0 0 31.272 40.579",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-67 -4.363)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.487,100.439H68.171A1.168,1.168,0,0,1,67,99.27V63.646a1.168,1.168,0,0,1,1.168-1.168H95.655V99.27A1.168,1.168,0,0,1,94.487,100.439Z",
    transform: "translate(0 -55.497)",
    fill: "#26B963"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.474,72.451H96.158a1.168,1.168,0,0,1-1.168-1.168V35.659a1.168,1.168,0,0,1,1.168-1.168h26.315a1.168,1.168,0,0,1,1.168,1.168V71.283A1.168,1.168,0,0,1,122.474,72.451Z",
    transform: "translate(-25.369 -30.128)",
    fill: "#26B963"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(75.185 8.668)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.522,
    height: 1.46,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17.522,
    height: 1.46,
    transform: "translate(0 5.196)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17.522,
    height: 1.46,
    transform: "translate(0 10.391)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17.522,
    height: 1.46,
    transform: "translate(0 15.587)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(75.185 29.373)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.522,
    height: 1.46,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17.522,
    height: 1.46,
    transform: "translate(0 5.196)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaDocument);
export default __webpack_public_path__ + "static/media/media-document.28a2d9fe6775f1987d14f3d565b11deb.svg";
export { ForwardRef as ReactComponent };